import { Language } from 'types/types';

export const LOCALE: { [key: string]: Language } = {
  KR: 1,
  ENG: 2,
  VNM: 3,
};
